import { getHeader, hashReqDecodeData, hashResEncodeData, getFormDataHeader } from "../helper";
import api from "../api";
import { SC, url } from "../config";



const handelLogout = (error) => {

          localStorage.removeItem('isAuthenticated');
          localStorage.removeItem('address');
          localStorage.removeItem('user_data');
          localStorage.removeItem('is_authenticated_false');
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('socket_group_id')
          sessionStorage.removeItem('loading')
    window.location.href = url;
}

let lougoutCall = false
//getFormDataHeader
export const makeFormDataRequestPost = async (URL, DATA) => {

    // const encrypted_data = DATA ? (SC === 0 ? DATA : hashResEncodeData(DATA)) : "";

    const { data } = await api.post(URL, DATA, getFormDataHeader()).catch((error) => {

        if (error.response && error.response.status === 401) {
            localStorage.removeItem('isAuthenticated');
            sessionStorage.removeItem('user');
            window.location.href = url;
        }
    });

    if (SC == 1 && data?.data?.length > 0) {
        const decrypted_data = hashReqDecodeData(data?.data)
        data.data = decrypted_data;
    }

    if (data && data?.user_status === false) {
        // if (data && data.user_status !== undefined && !data.user_status) {
        localStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('user');
        window.location.href = url;
    } else {
        return data
    }
}

export const makeRequestPost = async (URL, DATA) => {
    const encrypted_data = DATA ? (SC === 0 ? DATA : hashResEncodeData(DATA)) : "";

    const { data } = await api.post(URL, encrypted_data, getHeader()).catch(function (error) {
        if (error?.response && error?.response?.status === 401 && URL != 'logout') {
            const message = error?.response?.data?.message || 'Session Expired. Please Login Again';
            showErrorDialog(message);
            localStorage.setItem('is_authenticated_false' , '1');
            return error?.response?.data;
        }
    });
   
    

    if (SC == 1 && data?.data?.length > 0) {
        const decrypted_data = hashReqDecodeData(data?.data)
        data.data = decrypted_data;
    }    

    if (data && data?.user_status === false) {
        //  console.log('postsss', data);
        // if (data && data.user_status !== undefined && !data.user_status) {
        localStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('user');
        // window.location.href = url;
    } else {
        return data
    }
}

export const makeRequestGet = async (URL) => {
    const { data } = await api.get(URL, getHeader()).catch(function (error) {
        if (error?.response && error?.response?.status === 401) {
            const message = error?.response?.data?.message || 'Session Expired. Please Login Again';
            showErrorDialog(message);
            return error?.response?.data;
        }
    });

    if (SC == 1 && data?.data?.length > 0) {
        const decrypted_data = await hashReqDecodeData(data?.data)
        data.data = decrypted_data;
    }


    if (data && data?.user_status === false) {
        // if (data && data?.user_status !== undefined && !data?.user_status) {
        localStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('user');
    } else {
        return data
    }
}



const showErrorDialog = (message) => {
    const modalId = `errorModal_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const closeButtonId = `closeButton_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    const dialogHtml = `
        <div class="modal fade show d-block" id="${modalId}" tabindex="-1" role="dialog" style="z-index: 100000;">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" style="border-radius: 15px;">
                    <div class="modal-body text-center p-4" style="background-color: white; border-radius: 10px;">
                        <p class="text-dark mt-3 mb-5" style="font-size: 14px; line-height: 1.7;">${message}</p>
                        <div class="text-center">
                            <button class="btn btn-primary btn-sm btnFUll_Bg" style="font-size: 15px; font-weight: 500; border-radius: 8px; color: white;" id="${closeButtonId}">${localStorage.getItem('lang') == 'tr' ? 'Tamam' : 'Okay'}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" data-cevaheer-session-backdrop="1" style="z-index: 99999;"></div>
    `;

    // Insert the dialog into the DOM
    document.body.insertAdjacentHTML('beforeend', dialogHtml);

    // Function to close the modal
    const closeModal = () => {
       handelLogout()
    };

    // Use setTimeout to ensure DOM is ready, then attach event listener
    setTimeout(() => {
        const closeButton = document.getElementById(closeButtonId);
        
        if (closeButton) {
            // Remove any existing event listeners by cloning and replacing
            const newCloseButton = closeButton.cloneNode(true);
            closeButton.parentNode?.replaceChild(newCloseButton, closeButton);
            
            // Add the event listener to the new button
            newCloseButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
            });
        } else {
            console.error('Close button not found');
        }
    }, 0);

    // Also allow closing by clicking on the backdrop we just inserted
    setTimeout(() => {
        const backdrop = document.querySelector(`#${modalId}`)?.nextElementSibling;
        if (backdrop && backdrop.getAttribute('data-cevaheer-session-backdrop') === '1') {
            backdrop.addEventListener('click', () => {
                closeModal();
            });
        }
    }, 0);
};

